import { Component, ErrorInfo, ReactNode } from "react";
import { toAbsoluteUrl } from "@/../../src/_metronic/helpers";

import { Error500 } from "@/modules/errors/components/Error500";

interface ErrorBoundaryProps {
	children: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): ErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		console.error("ErrorBoundary capturou uma exceção de render:", error, errorInfo);
	}

	private handleReload = (): void => {
		window.location.reload();
	};

	render(): ReactNode {
		if (!this.state.hasError) {
			return this.props.children;
		}

		return (
			<div className="d-flex flex-column flex-root">
				<div
					className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
					style={{
						backgroundImage: `url('${toAbsoluteUrl(
							"/media/illustrations/progress-hd.png"
						)}')`,
					}}
				>
					<div className="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20">
						<div className="mb-10 pt-lg-20">
							<img
								alt="Logo"
								src={toAbsoluteUrl("/media/logos/multisus-azul.png")}
								className="h-85px mb-5"
							/>
						</div>
						<div className="pt-lg-10 mb-10">
							<Error500 />
							<div className="text-center">
								<button
									type="button"
									onClick={this.handleReload}
									className="btn btn-lg btn-primary fw-bolder"
								>
									Recarregar a página
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ErrorBoundary };
